<template>
  <div class="white_theme quote-content full_height">
    <!-- 盘口 -->
    <div class="quote-left full_height">
      <p @click="goBack" v-if="isOk" style="cursor: pointer;margin: -6px 0px 0px;">< Back</p>
      <div class="component-charts">
        <handicap
          :code="code"
          :throttle="throttle"
        ></handicap>
        <div class="component-chart">
          <quote-graph
            :throttle="throttle"
            :code="code"
          ></quote-graph>
        </div>
      </div>
    </div>
    <!-- 成分股和指数比较 -->
    <div class="quote-right">
      <div class="quote_div">
        <ul class="x-tab-bar">
          <li
            @click="cur=0"
            :class="{active:cur==0}"
          >Ranking constituent shares</li>
          <li
            @click="cur=1"
            :class="{active:cur==1}"
          >Index comparison</li>
        </ul>
        <constituentsRank
          v-if="cur==0"
          class="component_div"
          @clickProd="getProdElement"
          :prod_code="code"
          :throttle="throttle"
        ></constituentsRank>
        <indexCompare
          v-if="cur==1"
          class="component_div"
          :throttle="throttle"
          @clickProd="getProdInfo"
        ></indexCompare>
      </div>

      <div>
        <div class="title">
          <div>Transaction details</div>
        </div>
        <transDetail
          class="component_div"
          :prod_code="code"
          :throttle="throttle"
        ></transDetail>
      </div>
    </div>
  </div>
</template>

<script>
// 打包前
import x from './packages/build.js'
const { quoteGraph, handicap, transDetail, constituentsRank, indexCompare, handicapPrice } = x
import { getQueryString } from "./utils/assist";
export default {
  name: "App",
  data() {
    return {
      code: "989001.CNI", // 股票代码沪深：000001.SS,外汇：
      // 000001.SZ   000001.SS   399001.SZ    600570.SS IF1910.CCFX
      throttle: 3000, // 定时请求时间间隔 单位:ms
      cur: 0,
      tableData: [],
      zxCode: "xhcpt,cptmkt,topcptmkt",
      startnum: 0,
      length: "30",
      title: "新华行情",
      isLoad: true, //是否可以加载数据
      isOk: false,
    };
  },
  components: {
    quoteGraph, handicap, transDetail, constituentsRank, indexCompare, handicapPrice
  },
  created() {
    this.getcode();
    this.getTitle();
  },
  mounted(){
    if (this.$route.path == '/Finance/Xinhua500Index') {
      this.isOk = true;
    }
  },
  methods: {
    goBack() {
      this.$router.push("/ChinaInformationV2/1");
    },
    getcode() {
      let newCode = getQueryString("code");
      if (newCode) {
        this.code = newCode;
      }
    },
    getTitle() {
      let newTitle = getQueryString("title");
      if (newTitle) {
        this.title = newTitle;
        document.title = this.title;
      }
    },
    getProdInfo(data) {
      // let url =
      //   window.location.href.split("#")[0] +
      //   "#/dashboard?code=" +
      //   data.code +
      //   "&title=" +
      //   this.title;
      // window.open(url);
      // console.log("指数比较点击结果 ", data);
    },
    getProdElement(data) {
      // let url =
      //   window.location.href.split("#")[0] +
      //   "#/stock?code=" +
      //   data.code +
      //   "&title=" +
      //   this.title;
      // window.open(url);
      // console.log("成分股点击结果 ", data);
    },
    //返回数据公共处理部分
    dataPublic(len) {
      this.startnum += len;
    },
  }
};
</script>
<style scoped>
.full_height {
  position: relative;
}
.quote-content {
  flex: 1 1 auto;
  display: flex;
  height: 100%;
  width: 100%;
}
.quote-left {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: calc(100% - 310px);
}
.component-charts {
  height: calc(100% - 0px);
  width: calc(100%);
}
.list {
  height: calc(30%);
  width: 100%;
  margin-top: 4px;
  display: flex;
}
.list div {
  width: calc(50% - 5px);
  border: 1px solid #cacaca;
  box-sizing: border-box;
}
.list .gglist {
    margin-left: 10px;
  }
.component-chart {
  height: calc(100% - 75px);
  clear: both;
  background: #fff;
}
.component-chart > div {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.quote-right {
  margin-left: 10px;
  clear: both;
  display: flex;
  flex-direction: column;
}
.quote-right .quote_div {
  height: 46.6vh;
  background: #fff;
}
.quote-right > div:last-child {
  height: 37.25vh;
  margin-top: 10px;
  background: #fff;
}
.component_div {
  width: 300px;
  height: calc(100% - 50px);
  overflow-y: auto;
}

.x-tab-bar {
  height: 33px;
  background-color: #399bff;
  width: 100%;
  display: flex;
  list-style: none;
  font-size: 10px;
  margin: 0;
  padding: 0;
}
.x-tab-bar li {
  display: flex;
  width: 150px;
  padding-left: 5px;
  line-height: 33px;
  color: #ffffff;
  cursor: pointer;
}
.x-tab-bar li:hover {
  background-color: #338be5;
}
.x-tab-bar .active {
  color: #222;
  border-bottom: 1px solid #3a98e8;
  background-color: #fff !important;
}
.title {
  height: 32px;
  line-height: 32px;
  border-bottom: 1px solid #399bff;
  display: flex;
  padding-top: 0;
}
.title div {
  width: 180px;
  padding-left: 15px;
}

v-deep .graph1 {
  flex: 1;
}
</style>
